<dev-together-auth-wrapper>
  <p paragraph routerLink="/login">Have an account?</p>

  <button
    dev-together-button-retro
    text="Register"
    insideColor="#f04f65"
    hoverColor="#2acdc1"
    [loading]="status$ | async"
    (click)="submit()"
  ></button>
</dev-together-auth-wrapper>
